import React from 'react';
import glamorous, {withTheme, Div, H1, H3, P, Img, A} from 'glamorous';

import logo from '../../viska@2x.png';
import hand from './hand.png';
import content from './content';
import Video from './Video';
import GooglePlayBadge from './google-play-badge.svg';
import AppStoreBadge from './app-store-badge.svg';
import heart from './heart.svg';
import theme from './theme';

const Desktop = ({onOpenModal, theme}) =>
  <Div display="flex" flex="1" minHeight="100vh">
    <Div
      background={`linear-gradient(45deg, #FFB444, 30%, ${theme.baseColor})`}
      backgroundGra
      width="600px"
      display="flex"
      justifyContent="center"
      position="relative"
      minHeight="750px"
    >
      <Img position="absolute" top="50" width="100px" src={logo} />
      <Img position="absolute" bottom="0" left="0" width="88%" src={hand} />
      <Div position="absolute" left="200px" bottom="213px" width="199px">
        <Video autoPlay />
      </Div>
    </Div>
    <Div
      padding="100px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flex="1"
      position="relative"
      minHeight="500px"
    >
      <Div maxWidth="500px" color={theme.textColor}>
        <H1 fontFamily={theme.fontLight} fontSize="36" lineHeight="1.4em">
          {content.title}
        </H1>
        <P fontFamily={theme.fontLight} lineHeight="1.8em">
          {content.body}
        </P>
        <Div
          marginTop="50px"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Div marginTop="13px">
            <A href="http://apple.co/2saa65a" target="_blank">
              <Img marginRight="10px" src={AppStoreBadge} />
            </A>
            <A href="https://bit.ly/2rvr0Js" target="_blank">
              <Img src={GooglePlayBadge} />
            </A>
          </Div>
        </Div>
        <Div
          fontSize="12px"
          fontFamily={theme.fontLight}
          color={theme.lightColor}
          textAlign="center"
          marginTop="50px"
        >
          <Div marginBottom="5px">
            Made with
            {' '}
            <Img width="1em" src={heart} />
            {' '}
            in Iceland
          </Div>
          <A
            textDecoration="none"
            color={theme.lightColor}
            href="mailto://hello@viska.com"
            transition="200ms all"
            css={{
              ':hover': {
                color: theme.baseColor
              }
            }}
          >
            hello@viska.com
          </A>
          <Div marginTop="5px">
            Supported by
            {' '}
            <Img width="6em" src={require('./rannis.png')} />
            {' '}
          </Div>
        </Div>
      </Div>
    </Div>
  </Div>;

export default withTheme(Desktop);



// WEBPACK FOOTER //
// ./src/pages/Landing/Desktop.js